<template>
  <n-card class="intervention-step-card mt-6">
    <v-row no-gutters align="center" class="intervention-step-header">
      <div>
        <v-row no-gutters align="center" justify="center" class="ml-5 mr-4">
          <v-icon class="intervention-step-avatar">account_circle</v-icon>
        </v-row>
      </div>
      <v-col>
        <div>
          <v-row no-gutters justify="start" align="end">
            <div class="intervention-step-user">
              {{ `${step.user.firstname} ${step.user.lastname}` }}
            </div>
            <div class="pl-1 font-italic grey--text" style="font-size: 12px; padding-bottom: 2px;">
              - {{ userClientName }}
            </div>
          </v-row>
        </div>
        <div class="intervention-step-date">Le {{ step.$createdAt }}</div>
      </v-col>
      <div v-if="showStatus">
        <v-row no-gutters align="center" justify="end">
          <div class="intervention-step-status" :style="{ 'background-color' : step.status.color, color: statusFontColor(step.status) }">
            {{ step.status.name }}
          </div>
        </v-row>
      </div>
    </v-row>
    <v-row no-gutters class="intervention-step-body py-4 px-5">
      <div v-html="step.$description"></div>
    </v-row>
  </n-card>
</template>

<script>
import moment from 'moment';
import { mapGetters } from 'vuex';

export default {
  name: `InterventionStepCard`,
  props: {
    value: {
      type: Object,
      required: true,
    },
    showStatus: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
  data: () => ({
  }),
  computed: {
    step() {
      const $createdAt = moment(this.value.createdAt).format(`D MMMM YYYY [à] HH[h]mm`);
      const $description = this.value.description.replace(/\r\n|\r|\n/g, `<br />`);
      return {
        ...this.value,
        $description,
        $createdAt,
      };
    },
    ...mapGetters(`model/intervention`, [
      `statusFontColor`,
    ]),
    userClientName() {
      if (this.step.user.Client_id === this.step.intervention.Maker_id) {
        return this.step.intervention.maker.name;
      }

      return this.step.intervention.client.name;
    },
  },
};
</script>

<style lang="scss">
.intervention-step-card {
  // margin-top: 25px;
  padding-top: 10px;
  .intervention-step-header {
    padding-bottom: 10px;
    border-bottom: 1px solid #E2E2E2;
  }
  .intervention-step-status {
    text-align: center;
    background-color: #AAA;
    color: #FFF;
    border-radius: 15px 0px 0px 15px;
    font-size: 0.8rem;
    font-weight: 500;
    // margin-top: -5px;
    padding: 5px 20px;
    // min-width: 100px;
  }
  .intervention-step-avatar {
    font-size: 1.9rem;
    color: #444;
  }
  .intervention-step-user {
    font-size: 1.1rem;
    font-weight: 500;
  }
  .intervention-step-date {
    font-size: 0.7rem;
    color: #777;
  }
  .intervention-step-body {
    color: #444;
  }
}
</style>
